<template>
  <footer class="footer">
    <div class="content has-text-centered">
      <p>
        <strong>Beating Bookies</strong> by
        <a href="https://arpankc.com">Arpan Kc</a>. The source code is licensed
        <a href="http://opensource.org/licenses/mit-license.php">MIT</a>.
      </p>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'Footer',
};
</script>

<style scoped>
    a{
        color:purple;
        font-weight: bold;
    }
</style>
